import { ReactNode } from 'react';

export const getTexts = (
    freeWithPurchaseType: number
) : {
    title: string,
    content: ReactNode
} => {

    const title = freeWithPurchaseType === 1 ? 'Waves Update Plan' : 'Updates & Support';
    const content = freeWithPurchaseType === 1 ?
        <span>All selected software products in your cart include free updates for one year.</span>
        :
        <span>Your Waves Subscription Plan includes free plugin updates,  free premium content, and full access to Waves Technical Support.</span>;

    return {
        title,
        content,
    };
};